import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Footer from '../../../components/footer/footer';
import ShopNav from '../../../components/shopNav/ShopNav';
import NavCategorias from '../../../components/navbar/NavCategorias';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './ResetPassword.css';

const API_URL = import.meta.env.VITE_API_URL;


const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Token inválido o ausente en la URL');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (newPassword !== confirmPassword) {
      return setError('Las contraseñas no coinciden');
    }

    try {
      setSubmitting(true);
      const response = await axios.post(`${API_URL}/authStore/reset-password`, {
        token,
        newPassword,
      });

      setMessage(response.data.message);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al restablecer la contraseña');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="reset-page">
      <ShopNav />
      <NavCategorias />
      <main className="reset-page-main">
        <section className="reset-page-hero reset-page-elevated-wrap reset-page-elevated-wrap--hero">
          <div className="container reset-page-hero-inner">
            <div className="reset-page-hero-copy">
              <h1 className="display-5">Configura tu nueva contrasena</h1>
              <p className="lead">
                Restablece tu acceso de forma segura y vuelve a tu cuenta para continuar con tus compras.
              </p>
            </div>
            <div className="reset-page-hero-logo-wrap" aria-hidden="true">
              <img src="/images/VPA.png" alt="Vintage Pro Audio" className="reset-page-hero-logo" />
            </div>
          </div>
        </section>

        <section className="container reset-content-wrap">
          <div className="reset-form-shell">
            <div className="reset-form-head text-center">
              <h3 className="reset-form-title">Restablecer contrasena</h3>
              <p className="reset-form-subtitle">Escribe y confirma tu nueva clave.</p>
            </div>

            <div className="reset-form-body">
              {message && (
                <>
                  <div className="alert alert-success text-center reset-server-success">{message}</div>
                  <div className="text-center mt-4">
                    <button
                      className="btn d-flex align-items-center justify-content-center gap-2 mx-auto reset-login-btn"
                      onClick={() => navigate('/loginVpStore')}
                    >
                      <i className="bi bi-box-arrow-in-right"></i>
                      Iniciar sesion ahora
                    </button>
                  </div>
                </>
              )}

              {error && <div className="alert alert-danger reset-server-error">{error}</div>}

              {!message && (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="newPassword" className="form-label reset-form-label">Nueva contrasena</label>
                    <div className="input-group reset-input-group">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className="form-control reset-input"
                        id="newPassword"
                        required
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn reset-password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? 'Ocultar' : 'Mostrar'}
                      </button>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="confirmPassword" className="form-label reset-form-label">Confirmar contrasena</label>
                    <div className="input-group reset-input-group">
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        className="form-control reset-input"
                        id="confirmPassword"
                        required
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn reset-password-toggle"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      >
                        {showConfirmPassword ? 'Ocultar' : 'Mostrar'}
                      </button>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn w-100 reset-submit-btn"
                    disabled={submitting}
                  >
                    {submitting ? 'Restableciendo...' : 'Restablecer contrasena'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ResetPassword;
